const colorsGray = require('./scale-gray');

module.exports = colorsGray;
